import home from './src/home.vue'
import DeviceView from './src/DeviceView/DeviceView.vue' //设备列表

let views = {
    home,
    DeviceView,
};

export default views;